import { useContext } from "react"
import { useSelector } from "react-redux"
import Appointments from "../../../appointments/Appointments"
import { getCaseIdFromCasePayload } from "../../../../lib/caseUpdateHelpers"
import { WorkQueueUpdateContext } from "../../../work_queues/pages/drawer/WorkQueueUpdateContext"

export default function AppointmentsDetails({ subscribeRemoteList = true }) {
    const ctx = useContext(WorkQueueUpdateContext)
    const activeCase = useSelector((state) => state.case.activeCase)
    const caseId = ctx?.caseId ?? getCaseIdFromCasePayload(activeCase)

    return <Appointments caseIdFromDetails={caseId} subscribeRemoteList={subscribeRemoteList} />
}
